import { ligainicial } from "./rutainicial.js";
import { pagesipdus } from "./rutainicial";

const ligabase = ligainicial + "2026/Lic/C";
const ligasipdus = pagesipdus + "2026/Lic/C";
const ligasipdusInv = pagesipdus + "2026/Inv/";

export const licitacionesVigentes = [
    {
        // CONVOCATORIA NUM# 039
        'numConvocatoria' : 'Convocatoria No. 039/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N129-2026.',
        'vigencia' : '31 de agosto a 11 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Adecuación Integral de las Instalaciones en la Escuela de Música; de Cobertura Estatal',
        'urlAnexos' : `${ ligasipdus }39/N129/N129.rar`,
        'start' : '2026-08-31',
        'end' : '2026-09-11',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N128-2026.',
        'vigencia' : '31 de agosto a 11 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción de pavimentación de concreto hidráulico en la localidad El Jiadi, El Palomo, en la calle Prolongación Álvaro Obregón y División del Sur, en el municipio de El Arenal.; ubicada en la localidad de El Jiadi, Municipio de El Arenal, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }39/N128/N128.rar`,
        'start' : '2026-08-31',
        'end' : '2026-09-11',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N127-2026.',
        'vigencia' : '31 de agosto a 11 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción de pavimentación de concreto hidráulico en El Arenal en varias calles, en el municipio de El Arenal.; ubicada en la localidad y Municipio de El Arenal, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }39/N127/N127.rar`,
        'start' : '2026-08-31',
        'end' : '2026-09-11',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N126-2026.',
        'vigencia' : '31 de agosto a 11 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Ampliación de Red de Distribución en las Colonias 20 de noviembre, Santa Bárbara y La Isleta, en el municipio de Tepeapulco.; ubicada en Varias localidades del Municipio de Tepeapulco, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }39/N126/N126.rar`,
        'start' : '2026-08-31',
        'end' : '2026-09-11',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N125-2026.',
        'vigencia' : '31 de agosto a 11 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación de la lateral de servicios y sobre puente del Blvd. Luis D. Colosio frente a Plaza del Valle, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }39/N125/N125.rar`,
        'start' : '2026-08-31',
        'end' : '2026-09-11',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N124-2026.',
        'vigencia' : '31 de agosto a 11 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción de Alumbrado sobre Áreas Peatonales en el Perímetro de la Glorieta 24 Horas, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }39/N124/N124.rar`,
        'start' : '2026-08-31',
        'end' : '2026-09-11',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N123-2026.',
        'vigencia' : '31 de agosto a 11 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación del acceso principal Almoloya, en el municipio de Almoloya.; ubicada en la localidad y Municipio de Almoloya, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }39/N123/N123.rar`,
        'start' : '2026-08-31',
        'end' : '2026-09-11',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N122-2026.',
        'vigencia' : '31 de agosto a 11 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación de la C.E. Metepec - Tortugas - Acocul, segunda etapa, en el municipio de Metepec.; ubicada en la localidad de Tortugas, Municipio de Metepec, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }39/N122/N122.rar`,
        'start' : '2026-08-31',
        'end' : '2026-09-11',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N121-2026.',
        'vigencia' : '31 de agosto a 11 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Reconstrucción de pavimentación asfáltica del paso principal por la localidad de Benito Juárez, en el municipio de Mineral del Chico.; ubicada en la localidad de Benito Juárez, Municipio de Mineral del Chico, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }39/N121/N121.rar`,
        'start' : '2026-08-31',
        'end' : '2026-09-11',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N120-2026.',
        'vigencia' : '31 de agosto a 11 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Ampliación y rehabilitación del tramo carretero Tlanalapa - Cd. Sahagún, acceso principal, (segunda etapa) en el municipio de Tlanalapa.; ubicada en la localidad y Municipio de Tlanalapa, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }39/N120/N120.rar`,
        'start' : '2026-08-31',
        'end' : '2026-09-11',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N119-2026.',
        'vigencia' : '31 de agosto a 11 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en tramo Las Conchas - Santa Rosalía, en el municipio de Omitlán de Juárez.; ubicada en la localidad de San Antonio el Paso, Municipio de Omitlán de Juárez, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }39/N119/N119.rar`,
        'start' : '2026-08-31',
        'end' : '2026-09-11',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N118-2026.',
        'vigencia' : '31 de agosto a 11 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Repavimentación del boulevard acceso a Epazoyucan, E.C.F. Pachuca - Tulancingo, en el municipio de Epazoyucan.; ubicada en la localidad y Municipio de Epazoyucan, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }39/N118/N118.rar`,
        'start' : '2026-08-31',
        'end' : '2026-09-11',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N117-2026.',
        'vigencia' : '31 de agosto a 11 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Pavimentación de Concreto Hidráulico en calle Caoba y calle Bambú, localidad de Barrio El Judío, en el municipio de Pachuca de Soto.; ubicada en la localidad de Barrio el Judío, Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }39/N117/N117.rar`,
        'start' : '2026-08-31',
        'end' : '2026-09-11',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 038
        'numConvocatoria' : 'Convocatoria No. 038/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N116-2026.',
        'vigencia' : '24 de agosto al 4 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Mantenimiento de Cuartel del Arte.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo. (segundo procedimiento)',
        'urlAnexos' : `${ ligasipdus }38/N116/N116.rar`,
        'start' : '2026-08-24',
        'end' : '2026-09-04',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N115-2026.',
        'vigencia' : '24 de agosto al 4 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Programa Estatal para el Fortalecimiento de la Infraestructura de los Mercados Municipales San Bartolo Tutotepec; ubicada en la localidad y Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
        'urlAnexos' : `${ ligasipdus }38/N115/N115.rar`,
        'start' : '2026-08-24',
        'end' : '2026-09-04',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N114-2026.',
        'vigencia' : '24 de agosto al 4 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción de Corredor Artesanal y Gastronómico ubicado en la cabecera municipal de Singuilucan; ubicada en la localidad y Municipio de Singuilucan, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }38/N114/N114.rar`,
        'start' : '2026-08-24',
        'end' : '2026-09-04',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N113-2026.',
        'vigencia' : '24 de agosto al 4 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Centro Turístico multifuncional "Los Lavaderos", centro histórico Mineral del Chico; ubicada en la localidad y Municipio de Mineral del Chico, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }38/N113/N113.rar`,
        'start' : '2026-08-24',
        'end' : '2026-09-04',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 037
        'numConvocatoria' : 'Convocatoria No. 037/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N112-2026.',
        'vigencia' : '17 al 31 de agosto de 2026.',
        'descripcionProcedimiento' : 'Reconstrucción de la C.E. Agua Blanca-Zacualpa (tercera etapa); en el municipio de Agua Blanca de Iturbide.; ubicada en Varias localidades del Municipio de Agua Blanca de Iturbide, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }37/N112/N112.rar`,
        'start' : '2026-08-17',
        'end' : '2026-08-31',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N111-2026.',
        'vigencia' : '17 al 31 de agosto de 2026.',
        'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Andrés Quintana Roo, El Salto, municipio de Epazoyucan.; ubicada en la localidad y Municipio de Epazoyucan, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }37/N111/N111.rar`,
        'start' : '2026-08-17',
        'end' : '2026-08-31',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N110-2026.',
        'vigencia' : '17 al 31 de agosto de 2026.',
        'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle de acceso al plantel CECYTEH, en el municipio de Francisco I. Madero.; ubicada en la localidad de San Juan Tepa, Municipio de Francisco I. Madero, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }37/N110/N110.rar`,
        'start' : '2026-08-17',
        'end' : '2026-08-31',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N109-2026.',
        'vigencia' : '17 al 31 de agosto de 2026.',
        'descripcionProcedimiento' : 'Pavimentación hidráulica en Av. Javier Rojo Gómez, en el municipio de Huichapan.; ubicada en la localidad y Municipio de Huichapan, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }37/N109/N109.rar`,
        'start' : '2026-08-17',
        'end' : '2026-08-31',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N108-2026.',
        'vigencia' : '17 al 31 de agosto de 2026.',
        'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico de calle Sur 110, El Cerrito, municipio de Zempoala.; ubicada en la localidad de El Cerrito de Téllez, Municipio de Zempoala, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }37/N108/N108.rar`,
        'start' : '2026-08-17',
        'end' : '2026-08-31',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N107-2026.',
        'vigencia' : '17 al 31 de agosto de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación integral de calle Constitución, en cabecera municipal, en el municipio de Villa de Tezontepec.; ubicada en la localidad de Tezontepec, Municipio de Villa de Tezontepec, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }37/N107/N107.rar`,
        'start' : '2026-08-17',
        'end' : '2026-08-31',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N106-2026.',
        'vigencia' : '17 al 31 de agosto de 2026.',
        'descripcionProcedimiento' : 'Construcción de auditorio municipal de usos múltiples, primera etapa, en el municipio de Ixmiquilpan.; ubicada en la localidad y Municipio de Ixmiquilpan, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }37/N106/N106.rar`,
        'start' : '2026-08-17',
        'end' : '2026-08-31',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N105-2026.',
        'vigencia' : '17 al 31 de agosto de 2026.',
        'descripcionProcedimiento' : 'Encauzamiento y saneamiento del río Chinguiñoso, en el municipio de Huejutla de Reyes; ubicada en la localidad y Municipio de Huejutla de Reyes, Estado de Hidalgo.',
        'urlAnexos' : `${ ligasipdus }37/N105/N105.rar`,
        'start' : '2026-08-17',
        'end' : '2026-08-31',
        'procedimiento' : 'Licitación Pública',
    },
]